import { Lang } from "@custom-types/Types";
import { LANG } from "@resources/Constants";
import English from "./En.json";
import Korean from "./Ko.json";
import French from "./Fr.json";
import German from "./Ge.json";
import Spanish from "./Sp.json";
import Portuguese from "./Po.json";
import Italian from "./It.json";

type LangObject = {
  [key: string]: string | LangObject;
};

export const messages: { [key in Lang]: LangObject } = {
  [LANG.EN]: English,
  [LANG.KO]: Korean,
  [LANG.FR]: French,
  [LANG.GE]: German,
  [LANG.SP]: Spanish,
  [LANG.PO]: Portuguese,
  [LANG.IT]: Italian
};

export const flattenMessages = (nestedMessages: LangObject, prefix = "") => {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      Object.assign(messages, { [prefixedKey]: value });
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
    return messages;
  }, {});
};
